module.exports = __webpack_public_path__ + "static/media/10.4f28187d.jpg";